document.addEventListener('DOMContentLoaded', function() {
  // Flip caselle al click
  const boxes = document.querySelectorAll('.advent-box');
  boxes.forEach(box => {
    box.addEventListener('click', function() {
      const day = parseInt(box.dataset.day, 10);
      const today = new Date().getDate();
      if(day <= today) { // sblocca solo se giorno <= oggi
        box.classList.toggle('flipped');
      } else {
        alert('Questa casella non è ancora disponibile!');
      }
    });
  });

  // Neve
  const snowCount = 30;
  for(let i=0; i<snowCount; i++){
    const snow = document.createElement('div');
    snow.classList.add('snowflake');
    snow.style.left = Math.random()*100 + 'vw';
    snow.style.animationDuration = 3 + Math.random()*5 + 's';
    snow.style.fontSize = 10 + Math.random()*20 + 'px';
    snow.textContent = '❄';
    document.body.appendChild(snow);
  }
});
